import React from 'react';
import type { InspirationalGridProps } from 'Components/widgets/inspirational-grid/InspirationalGrid';
import { InspirationalGrid } from 'Components/widgets/inspirational-grid/InspirationalGrid';
export const InspirationalGridLine = ({
  description,
  layout,
  pictures,
  subtitle,
  title,
}: InspirationalGridProps) => {
  return (
    <div className="Line" id="inspirationalGrid">
      <InspirationalGrid
        description={description}
        layout={layout}
        pictures={pictures}
        subtitle={subtitle}
        title={title}
      />
    </div>
  );
};
